import React from 'react';
import { ContactListItem, Employee } from '../types/all-types';
import {
    GERMAN_PHONE_PREFIX,
    EMAIL_ADDRESS_SUFFIX,
    GERMAN_PHONE_NUMBER_HUMAN_READABLE_PREFIX,
    INTERNATIONAL_PHONE_NUMBER_PREFIX,
    VCARD_FOLDER_NAME,
} from '../constants';
import { getVcardFileName, i18nGermanPhoneNumber } from './helpers.js';

export const addTelToContactList = (
    contactList: ContactListItem[],
    employee: Employee
): ContactListItem[] => {
    if (employee.phoneNumberSuffix) {
        return [
            ...contactList,
            {
                label: 'Tel:',
                content: (
                    <a
                        href={`tel:${i18nGermanPhoneNumber(
                            GERMAN_PHONE_NUMBER_HUMAN_READABLE_PREFIX +
                                employee.phoneNumberSuffix
                        )}`}
                    >
                        {GERMAN_PHONE_NUMBER_HUMAN_READABLE_PREFIX}{' '}
                        {employee.phoneNumberSuffix}
                    </a>
                ),
            },
        ];
    } else {
        return contactList;
    }
};

export const addMobileToContactList = (
    contactList: ContactListItem[],
    employee: Employee
): ContactListItem[] => {
    if (employee.mobilePhoneNumber) {
        return [
            ...contactList,
            {
                label: 'Mobil:',
                content: (
                    <a
                        href={`tel:${i18nGermanPhoneNumber(
                            employee.mobilePhoneNumber
                        )}`}
                    >
                        {employee.mobilePhoneNumber}
                    </a>
                ),
            },
        ];
    } else {
        return contactList;
    }
};

export const addFaxToContactList = (
    contactList: ContactListItem[],
    employee: Employee
): ContactListItem[] => {
    if (employee.faxNumberSuffix) {
        return [
            ...contactList,
            {
                label: 'Fax:',
                content: (
                    <>
                        {GERMAN_PHONE_NUMBER_HUMAN_READABLE_PREFIX}{' '}
                        {employee.faxNumberSuffix}
                    </>
                ),
            },
        ];
    } else {
        return contactList;
    }
};

export const addVcardToContactList = (
    contactList: ContactListItem[],
    employee: Employee
): ContactListItem[] => [
    ...contactList,
    {
        content: (
            <a
                href={`/${VCARD_FOLDER_NAME}/${getVcardFileName(
                    employee.firstName,
                    employee.lastName
                )}`}
            >
                vCard (.vcf)
            </a>
        ),
    },
];

export const addEmailToContactList = (
    contactList: ContactListItem[],
    employee: Employee
): ContactListItem[] => {
    if (employee.emailAddressPrefix) {
        const fullEmailAddress =
            employee.emailAddressPrefix + EMAIL_ADDRESS_SUFFIX;
        return [
            ...contactList,
            {
                content: (
                    <a href={`mailto:${fullEmailAddress}`}>
                        {fullEmailAddress}
                    </a>
                ),
            },
        ];
    } else {
        return contactList;
    }
};
